module.exports = __webpack_public_path__ + "img/unit_White_A.61b01c9c.png";